import { api, ApiError } from "utils/api";
import { useAsync } from "utils/hooks";
import { UploadedImage } from "../types";

const getImageUploadUrl = (contentType: string): Promise<{ url: string }> =>
  api(`/upload_url?contentType=${contentType}`);

const putImageUpload = async (file: File): Promise<UploadedImage> => {
  const { url } = await getImageUploadUrl(file.type);

  const resp = await fetch(url, {
    method: "PUT",
    body: file,
  });

  if (!resp.ok) {
    throw new ApiError("Image upload failed", resp.status);
  }

  return {
    file,
    // Remove query string from AWS S3 URL
    url: url.indexOf("?") > -1 ? url.slice(0, url.indexOf("?")) : url,
  };
};

const useImageUpload = () => {
  const {
    data: upload,
    run: postUploadRun,
    ...uploadQuery
  } = useAsync<UploadedImage>();

  const runUpload = (file: File) => {
    postUploadRun(putImageUpload(file));
  };

  return {
    runUpload,
    upload,
    ...uploadQuery,
  };
};

export { useImageUpload };
